// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2_It7","header":"ReportDetails_header__2kstX","title":"ReportDetails_title__1klZU","left":"ReportDetails_left__2oG0C"};